import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { Client, Company, User } from 'src/constants/dataTypes';

export interface ExtraDataState {
  clients: Record<string, Client>; // CLIENT_USER objects
  users: Record<string, User>; // INTERNAL_USER objects
  companies: Record<string, Company>; // Company objects
}

const initialState: ExtraDataState = {
  clients: {},
  users: {},
  companies: {},
};

const extraDataSlice = createSlice({
  name: 'extraData',
  initialState,
  reducers: {
    setExtraData: (
      state,
      action: PayloadAction<{
        clients?: Record<string, Client>;
        users?: Record<string, User>;
        companies?: Record<string, Company>;
      }>,
    ) => {
      // Merge new extraData with existing data
      if (action.payload.clients) {
        state.clients = {
          ...state.clients,
          ...action.payload.clients,
        };
      }
      if (action.payload.users) {
        state.users = {
          ...state.users,
          ...action.payload.users,
        };
      }
      if (action.payload.companies) {
        state.companies = {
          ...state.companies,
          ...action.payload.companies,
        };
      }
    },
    updateExtraDataItem: (
      state,
      action: PayloadAction<{
        id: string;
        item: Client | Company;
        type: 'client' | 'user' | 'company';
      }>,
    ) => {
      if (action.payload.type === 'client') {
        state.clients[action.payload.id] = action.payload.item as Client;
      } else if (action.payload.type === 'user') {
        state.users[action.payload.id] = action.payload.item as User;
      } else if (action.payload.type === 'company') {
        state.companies[action.payload.id] = action.payload.item as Company;
      }
    },
    clearExtraData: (state) => {
      state.clients = {};
      state.users = {};
      state.companies = {};
    },
  },
});

export const { setExtraData, updateExtraDataItem, clearExtraData } =
  extraDataSlice.actions;

export default extraDataSlice.reducer;
